// extracted by mini-css-extract-plugin
export var detailedImgItem = "detailed-module--detailed-img-item--Le-mi";
export var highlightsRow = "detailed-module--highlightsRow--gkZ99";
export var subtitle = "detailed-module--subtitle--eNgjU";
export var time = "detailed-module--time--TXwzQ";
export var title = "detailed-module--title--m5Yn2";